import React from 'react';

import { Button } from '@components/Button';
import { DevLayout } from '@components/dev/DevLayout';
import { CheckboxBooleanInput } from '@components/NextForms/CheckboxBooleanInput';
import { CheckboxInput } from '@components/NextForms/CheckboxInput';
import { DebugForm } from '@components/NextForms/DebugForm';
import { FileInput } from '@components/NextForms/FileInput';
import { RadioInput } from '@components/NextForms/RadioInput';
import { RadioInputControl } from '@components/NextForms/RadioInputControl';
import { TextInput } from '@components/NextForms/TextInput';
import { LocalFile } from '@models/next/FileType';
import { useForm } from '@monoid-dev/mobx-zod-form-react';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { f } from '@utils/nextForms';
import { z } from 'zod';

const useStyles = makeMuiStyles((_, common) => ({
  form: {
    ...common.middleText,
    '& > label': {
      paddingTop: 6,
    },
  },
}));

export const NextForm: React.FC = () => {
  const classes = {
    ...useStyles(),
    ...useCommonStyles(),
  };

  const form = useForm(
    z.object({
      username: z.string().min(1),
      password: z.string().min(6),
      number: z.number(),
      select: z.string().min(1),
      date: f.dateString().label('date'),
      enum: z.enum(['A', 'B', 'C']),
      file: LocalFile,
      yen: f.yen(),
      checkbox: z.array(z.enum(['A', 'B', 'C'])),
      checkbox_boolean: z.boolean(),
      radio: z.enum(['A', 'B', 'C']),
      radioNumber: z.number(),
    }),
  );

  const fields = form.root.fields;

  return (
    <DevLayout>
      <div style={{ flex: 1, padding: 10 }}>
        <form
          className={classes.form}
          style={{
            maxWidth: 500,
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            columnGap: '1rem',
            rowGap: '0.5rem',
          }}
          {...form.bindForm({ onSubmit: console.info, onSubmitError: console.error })}
        >
          <label>Username</label>

          <div>
            <TextInput field={fields.username} />
          </div>

          <label>Password</label>

          <div>
            <TextInput field={fields.password} />
          </div>

          <label>Number</label>

          <div>
            <TextInput field={fields.number} />
          </div>

          <label>Select</label>

          <div>
            <TextInput
              field={fields.select}
              inputOptions={{
                type: 'choose',
                options: [
                  { label: 'SHIT', value: 'SHIT' },
                  { label: 'FUCK', value: 'FUCK' },
                ],
              }}
            />
          </div>

          <label>Date</label>
          <div>
            <TextInput field={fields.date} />
          </div>

          <label>Enum</label>
          <div>
            <TextInput field={fields.enum} />
          </div>

          <label>File</label>
          <div>
            <FileInput field={fields.file} />
          </div>

          <label>Yen</label>
          <div>
            <TextInput field={fields.yen} />
          </div>

          <label>Checkbox</label>
          <div>
            <CheckboxInput field={fields.checkbox} value={'A'} label={'A'} />
            <CheckboxInput field={fields.checkbox} value={'B'} label={'B'} />
            <CheckboxInput field={fields.checkbox} value={'C'} label={'C'} />
          </div>

          <label>Checkbox Boolean</label>
          <div>
            <CheckboxBooleanInput field={fields.checkbox_boolean} />
          </div>

          <label>Radio</label>
          <div>
            <RadioInput field={fields.radio} value="A" />
            <RadioInput field={fields.radio} value="B" />
            <RadioInput field={fields.radio} value="C" />
          </div>

          <label>Radio Number</label>
          <div>
            <div>
              <RadioInputControl field={fields.radioNumber} value={50} />
            </div>
            <div>
              <RadioInputControl field={fields.radioNumber} value={100} />
            </div>
            <div>
              <RadioInputControl field={fields.radioNumber} value={1000} />
            </div>
          </div>

          <div></div>
          <div>
            <Button color="primary" type="submit" text="submit" />
          </div>

          <div />
          <div>
            <DebugForm form={form} />
          </div>
        </form>
      </div>
    </DevLayout>
  );
};
